import { FC } from "react";

import CrisisAlertIcon from "@mui/icons-material/CrisisAlert";
import { Button, Card, useTheme } from "@mui/material";

import { Translate } from "@/components/Application/Translate";
import { tokens } from "@/components/Application/theme";

import { ComponentErrorProps } from "@/helpers/components/Errors/Types";

const ComponentError: FC<ComponentErrorProps> = ({ message, reset }) => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);
	return (
		<Card
			style={{
				color: colors.redAccent[400],
				padding: ".5rem",
				backgroundColor: colors.redAccent[900],
				borderColor: colors.redAccent[400],
				borderRadius: "5px",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				margin: "auto",
				gap: "1rem",
			}}
		>
			<CrisisAlertIcon sx={{ color: colors.redAccent[400] }} />
			<Translate String="Error.Common">
				<strong>An error occurred</strong>
			</Translate>

			<Button variant="outlined" color="error" onClick={reset}>
				<Translate String="Error.Button.Refresh">Try again</Translate>
			</Button>
			<Button
				variant="outlined"
				color="error"
				onClick={() => {
					window.location.reload();
				}}
			>
				<Translate String="Error.Button.Reload">Reload</Translate>
			</Button>
		</Card>
	);
};

export default ComponentError;
